import { render, staticRenderFns } from "./CallBox.vue?vue&type=template&id=1d5bfeff&scoped=true"
import script from "./CallBox.vue?vue&type=script&lang=js"
export * from "./CallBox.vue?vue&type=script&lang=js"
import style0 from "./CallBox.vue?vue&type=style&index=0&id=1d5bfeff&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5bfeff",
  null
  
)

export default component.exports